import { watch, toValue, type MaybeRefOrGetter } from 'vue'
import { useIntervalFn } from '@vueuse/core'

const POLLING_INTERVAL_MS = 20_000

/**
 * Polls `refresh` every 20 seconds while `hasProcessing` is true.
 * Automatically stops when `hasProcessing` becomes false.
 */
export function useSnapshotStatusPolling(
  hasProcessing: MaybeRefOrGetter<boolean>,
  refresh: () => Promise<void>,
) {
  const { pause, resume, isActive } = useIntervalFn(refresh, POLLING_INTERVAL_MS, {
    immediate: false,
  })

  watch(
    () => toValue(hasProcessing),
    (active) => {
      if (active) resume()
      else pause()
    },
    { immediate: true },
  )

  return { isPolling: isActive }
}
